import { createAction } from 'redux-starter-kit';

export const SET_REPORTS_TABLES = 'reports/SET_REPORTS_TABLES';
export const CLEAR_REPORTS_TABLES = 'reports/CLEAR_REPORTS_TABLES';
export const SET_REPORTS_HTMLS = 'reports/SET_REPORTS_HTMLS';
export const CLEAR_REPORTS_HTMLS = 'reports/CLEAR_REPORTS_HTMLS';

export default {
  setReportsTables: createAction(SET_REPORTS_TABLES),
  clearReportsTables: createAction(CLEAR_REPORTS_TABLES),
  setReportsHtmls: createAction(SET_REPORTS_HTMLS),
  clearReportsHtmls: createAction(CLEAR_REPORTS_HTMLS),
};
